"use strict";
/**
 * RedPanda UI - Loading Components Export
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.LoadingButton = exports.LoadingOverlay = exports.LoadingDots = exports.LoadingSpinner = exports.Loading = void 0;
var Loading_1 = require("./Loading");
Object.defineProperty(exports, "Loading", { enumerable: true, get: function () { return Loading_1.Loading; } });
Object.defineProperty(exports, "LoadingSpinner", { enumerable: true, get: function () { return Loading_1.LoadingSpinner; } });
Object.defineProperty(exports, "LoadingDots", { enumerable: true, get: function () { return Loading_1.LoadingDots; } });
Object.defineProperty(exports, "LoadingOverlay", { enumerable: true, get: function () { return Loading_1.LoadingOverlay; } });
Object.defineProperty(exports, "LoadingButton", { enumerable: true, get: function () { return Loading_1.LoadingButton; } });
